/** Active minutes as "3 h 25 m". Zero and junk become "0 m". Hours are omitted when zero. */
export function formatDuration(minutes: number): string {
  if (!Number.isFinite(minutes) || minutes <= 0) return "0 m";
  const total = Math.floor(minutes);
  const h = Math.floor(total / 60);
  const m = total % 60;
  if (h === 0) return `${m} m`;
  if (m === 0) return `${h} h`;
  return `${h} h ${m} m`;
}

/**
 * Clock time in the viewer's local zone, with that zone labelled.
 * Last Mehnat and Expires both use this so they share one zone.
 */
export function formatActiveWhen(iso: string | null): string {
  if (!iso) return "—";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return "—";
  const zone = Intl.DateTimeFormat().resolvedOptions().timeZone || "UTC";
  const clock = new Intl.DateTimeFormat("en-US", {
    month: "short",
    day: "numeric",
    year: "numeric",
    hour: "numeric",
    minute: "2-digit",
    timeZone: zone,
    timeZoneName: "short",
  }).format(d);
  return `${clock} (${zone})`;
}

export function timeInMittiLine(minutes: number, lastActiveAt: string | null): string {
  const none = !Number.isFinite(minutes) || minutes <= 0;
  if (none && !lastActiveAt) return "No Mehnat yet";
  return `Time in the Mitti ${formatDuration(minutes)} · last active ${formatActiveWhen(lastActiveAt)}`;
}

/** Hidden by the caller when this returns null (no Mehnat recorded yet). */
export function mehnatLine(minutes: number): string | null {
  if (!Number.isFinite(minutes) || minutes <= 0) return null;
  return `You've put in ${formatDuration(minutes)} on this Mitti`;
}
